import { inject } from 'aurelia';
import { IRouter } from '@aurelia/router';
import { PresentApi } from '../../apis/present/present-api';

@inject(IRouter, PresentApi)
export class PresentForm {
    public scheduleCode: string = '';
    public isLoading: boolean = false;
    public codeDoesNotExist: boolean = false;

    constructor(private readonly _router: IRouter, private readonly _presentApi: PresentApi) {}

    public loading(params: any): void {
        const code = params?.code ?? new URLSearchParams(window.location.search).get('code');
        if (code) {
            this.scheduleCode = String(code).toUpperCase();
            this.isLoading = true; // show spinner immediately, navigate in attached()
        } else {
            this.scheduleCode = '';
            this.isLoading = false;
            this.codeDoesNotExist = false;
        }
    }

    public async attached(): Promise<void> {
        if (this.isLoading) {
            await this._navigateToCode(this.scheduleCode);
        }
    }

    public get codeValid(): boolean {
        return this.scheduleCode?.length === 6;
    }

    public async getSchedule(): Promise<void> {
        await this._navigateToCode(this.scheduleCode.toUpperCase());
    }

    private async _navigateToCode(code: string): Promise<void> {
        this.codeDoesNotExist = false;
        this.isLoading = true;
        try {
            await this._presentApi.getByCode(code);
        } catch {
            this.codeDoesNotExist = true;
            this.isLoading = false;
            return;
        }
        void this._router.load(`present/${code}`);
    }
}
